import { Routes, Route, useLocation, HashRouter } from 'react-router-dom';
import { QuizProvider } from './contexts/QuizContext';
import { UserProvider } from './contexts/UserContext';
import GlobalStyles from './styles/GlobalStyles';
import { useEffect } from 'react';

// Componentes de página
import Welcome from './pages/Welcome';
import Question from './pages/Question';
import Loading from './pages/Loading';
import Results from './pages/Results';
import TestResults from './pages/TestResults';
import SimpleResults from './pages/SimpleResults';

// Componentes utilitários
import CookieConsent from './components/CookieConsent';
import WebhookSender from './components/WebhookSender';

// Funções de rastreamento
import { initTracking, sendEvent } from './utils/tracking';

// Componente para rastrear mudanças de rota e enviar PageView
function PageTracker() {
  const location = useLocation();

  // Efeito para monitorar mudanças na rota
  useEffect(() => {
    // Inicializar e configurar o rastreamento
    initTracking();

    // Enviar evento de visualização de página
    sendEvent('PageView', {
      content_name: 'Gateway Finder - ' + location.pathname,
      content_category: 'PageView',
      page_path: location.pathname
    });
  }, [location]);

  return null;
}

function App() {
  return (
    <QuizProvider>
      <UserProvider>
        <GlobalStyles />
        <HashRouter>
          <PageTracker />
          <WebhookSender />
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/question/:questionId" element={<Question />} />
            <Route path="/loading" element={<Loading />} />
            <Route path="/results" element={<Results />} />
            <Route path="/test-results" element={<TestResults />} />
            <Route path="/simple-results" element={<SimpleResults />} />
          </Routes>
          <CookieConsent />
        </HashRouter>
      </UserProvider>
    </QuizProvider>
  );
}

export default App;
